import axios, { AxiosResponse } from 'axios'

type HttpMethodType = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH'

interface RequestOptionsInterface<T> {
  data?: T
  // biome-ignore lint/suspicious/noExplicitAny: <explanation>
  params?: Record<string, any>
}

export const request = axios.create({
  baseURL: `${process.env.SYSTEME_IO_HOST}`,
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

export const websiteRequest = async <T, U = unknown>(
  url: string,
  method: HttpMethodType,
  options: RequestOptionsInterface<U> = {},
): Promise<T> => {
  try {
    const { data, params } = options
    const response: AxiosResponse<T> = await request({
      method,
      url: `/api/dashboard/website/${url}`,
      data,
      params,
    })
    return response.data
  } catch (error) {
    // biome-ignore lint/complexity/noUselessCatch: <explanation>
    throw error
  }
}
